module.exports = __webpack_public_path__ + "static/media/wall1.5d690994.jpg";